import React from 'react';

import Group from '@lightspeed/cirrus-group';
import Modal, { ModalBody, ModalFooter, ModalHeader } from '@lightspeed/cirrus-modal';
import Text, { TextContent } from '@lightspeed/cirrus-text';
import { Button } from '@lightspeed/flame/Button';
import { Box } from '@lightspeed/flame/Core';

import { createReactRenderer } from 'helpers/react-renderer';

interface Props {
  onConfirmation: (confirmation: boolean) => void;
}

export const CustomerConsentDialog: React.FC<Props> = ({ onConfirmation }) => {
  const [isOpen, setIsOpen] = React.useState(true);

  const handleCloseModal = () => {
    setIsOpen(false);
    onConfirmation(false);
  };

  const handleConfirmModal = () => {
    setIsOpen(false);
    onConfirmation(true);
  };

  return (
    <Modal className="cirrus responsive" isOpen={isOpen} onRequestClose={handleCloseModal}>
      <ModalHeader onCloseClicked={handleCloseModal}>
        The refund needs a card present to continue.
      </ModalHeader>
      <ModalBody style={{ maxWidth: '600px' }}>
        <Box width="600px">
          <TextContent>
            <Text bodySmall>
              Because this refund isn’t linked to the original sale, a card is required for this
              refund to be processed. You can continue or choose another refund type
            </Text>
          </TextContent>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Group className="cr-justify-end">
          <Button onClick={handleCloseModal}>Cancel</Button>
          <Button variant="primary" fill onClick={handleConfirmModal}>
            Continue
          </Button>
        </Group>
      </ModalFooter>
    </Modal>
  );
};

// eslint-disable-next-line
export const getConsent = async () => {
  return new Promise((resolve) => {
    const RenderedComponent = createReactRenderer({
      component: CustomerConsentDialog,
      selector: '[data-react-root="ReactModal"]',
      props: {
        onConfirmation: (confirmation) => {
          resolve(confirmation);

          if (!confirmation) {
            setTimeout(() => {
              try {
                // Safely unmount;
                RenderedComponent.unmount();
              } catch {
                // Do nothing
              }
            });
          }
        },
      },
    });
    RenderedComponent.mount();
  });
};
